import React from 'react';

interface CreatescreenProps {
    className?: string;
}

const Createscreen: React.FC<CreatescreenProps> = ({ className }) => {
    return (
        <svg
            className={className}
            fill="none"
            height="26"
            viewBox="0 0 26 26"
            width="26"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_281_90)">
                <g filter="url(#filter0_d_281_90)">
                    <path
                        d="M13 21.6665H2.81669C2.6443 21.6665 2.47897 21.598 2.35707 21.4761C2.23517 21.3542 2.16669 21.1889 2.16669 21.0165L2.16669 8.3935C2.16684 8.22117 2.23542 8.05595 2.35735 7.93417L5.76769 4.52384C5.82824 4.4632 5.9002 4.41514 5.9794 4.38242C6.0586 4.3497 6.14349 4.33296 6.22919 4.33317H23.1834C23.2687 4.33317 23.3532 4.34998 23.4321 4.38265C23.511 4.41531 23.5826 4.46319 23.643 4.52355C23.7033 4.58391 23.7512 4.65556 23.7839 4.73443C23.8165 4.81329 23.8334 4.89781 23.8334 4.98317V14.0832"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                    <path
                        d="M3 8.66646H5.85002C6.02241 8.66646 6.18774 8.59798 6.30964 8.47608C6.43154 8.35419 6.50002 8.18885 6.50002 8.01646L6.50002 5.49976M20.5834 23.8418V20.5918M20.5834 20.5918V17.3418M20.5834 20.5918H17.3334M20.5834 20.5918H23.8334"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeOpacity="0.5"
                        strokeWidth="2.5"
                    />
                </g>
            </g>
            <defs>
                <filter
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                    height="29.7588"
                    id="filter0_d_281_90"
                    width="31.9167"
                    x="-2.83331"
                    y="3.33301"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        result="hardAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        in2="BackgroundImageFix"
                        mode="normal"
                        result="effect1_dropShadow_281_90"
                    />
                    <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow_281_90"
                        mode="normal"
                        result="shape"
                    />
                </filter>
                <clipPath id="clip0_281_90">
                    <rect
                        fill="currentColor"
                        height="26"
                        transform="matrix(0 -1 1 0 0 26)"
                        width="26"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Createscreen;